<div class="qa-list">
  @for (item of items(); track item.question) {
  @switch (item.answer) {

  @case ('copies') {
    @if (displayFundingTransfer()) {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.copies' | translate }}
      </p>
      <p class="qa-list__answer">
        <span>
          {{ 'help-faq.answers.copies.displayFundingTransfer' | translate }}
        </span>
      </p>
    </div>
    }
    @else {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.copies' | translate }}
      </p>
      <p class="qa-list__answer">
        <span>
          {{ 'help-faq.answers.copies.DEFAULT' | translate }}
        </span>
      </p>
    </div>
    }
  }

  @case('who') {
    @if (!participantsLoading() && borrowerNames().length) {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.who' | translate }}
      </p>

      <p class="qa-list__answer">
        {{ 'help-faq.answers.who' | translate }}
      </p>

      <div class="qa-list__answer">
        <ul>
          @for (borrower of borrowerNames(); track borrower.id) {
          <li appHighlightData>{{ borrower.firstName }} {{ borrower.lastName }} ({{ borrower.roleDisplay | translate }})</li>
          }
          @for (participant of participantNames(); track participant.id) {
          <li appHighlightData>{{ participant.firstName }} {{ participant.lastName }} ({{ participant.roleDisplay | translate }})</li>
          }
        </ul>
      </div>
    </div>
    }
  }

  @case ('proof') {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.proof' | translate }}
    </p>

    <p class="qa-list__answer">
      {{ 'help-faq.answers.proof' | translate }}
    </p>
  </div>
  }

  @case ('nbthsign') {
  @if (hasNbthParticipants()) {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.nbthsign' | translate }}
    </p>

    <p class="qa-list__answer">
      {{ 'help-faq.answers.nbthsign' | translate }}
    </p>
  </div>
  }
  }

  @case ('autopay') {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.autopay' | translate }}
    </p>

    <p class="qa-list__answer">
      {{ 'help-faq.answers.autopay' | translate }}
    </p>
  </div>
  }

  @case ('discrepancies') {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.discrepancies' | translate }}
    </p>

    <p class="qa-list__answer">
      <span>{{ 'help-faq.CLOSING_TEAM_INTRO' | translate }} </span>
      <a class="qa-list__answer-phone" href="tel:8888485309">{{ 'help-faq.CLOSING_TEAM_PHONE' | translate }}</a>
    </p>
  </div>
  }

  @case ('escrow') {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.escrow' | translate }}
    </p>
    <p class="qa-list__answer">
      {{ 'help-faq.answers.escrow' | translate }}
    </p>
  </div>
  }

  @case('fundsdueatclosing') {
    @if (cashToCloseFinalIsFromBorrower()) {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.fundsdueatclosing' | translate }}
      </p>
      @if(displayFundingTransfer()) {
      <p class="qa-list__answer">
        {{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.INTRO' | translate }}
        <a href="https://www.rocketclose.com/funding/funding-transfers" target="_blank" rel="noopener noreferrer">{{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.LINK' | translate }}</a>{{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.OUTRO' | translate }}
      </p>
      } @else {
      <p class="qa-list__answer">
        {{ 'help-faq.answers.fundsdueatclosing.DEFAULT' | translate }}
      </p>
      }
    </div>
    }
  }

  @case ('incorrect') {
  <div>
    <p class="qa-list__question">
      {{ 'help-faq.questions.incorrect' | translate }}
    </p>
    <p class="qa-list__answer">
      <span>{{ 'help-faq.CLOSING_TEAM_INTRO' | translate }} </span>
      <a class="qa-list__answer-phone" href="tel:8888485309">{{ 'help-faq.CLOSING_TEAM_PHONE' | translate }}</a>
    </p>
  </div>
  }

  @case('loaninfo') {
    @if (hasData()) {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.loaninfo' | translate }}
      </p>

      @if(disbursementDate() !== '') {
      <p>
        {{ 'help-faq.loanTerms.DISBURSEMENT_DATE' | translate }} <span appHighlightData>{{disbursementDate()}}</span>
      </p>
      }

      @if(interestRate() !== '') {
      <p>
        {{ 'help-faq.loanTerms.INTEREST_RATE' | translate }} <span appHighlightData>{{interestRate()}}</span>
      </p>
      }

      @if(monthlyPayment() !== '') {
      <p>
        {{ 'help-faq.loanTerms.MONTHLY_PAYMENT' | translate }} <span appHighlightData>{{monthlyPayment()}}</span>
      </p>
      }

      @if(firstPaymentDate() !== '') {
      <p>
        {{ 'help-faq.loanTerms.FIRST_PAYMENT_DATE' | translate }} <span appHighlightData>{{firstPaymentDate()}}</span>
      </p>
      }

      @if(prepaymentPenalty() !== '') {
      <p>
        {{ 'help-faq.loanTerms.PREPAYMENT_PENALTY' | translate }} <span appHighlightData>{{prepaymentPenalty()}}</span>
      </p>
      }
    </div>
    }
  }

  @case('payoffs') {
    @if(payoffs().length) {
    <div>
      <p class="qa-list__question">{{ 'help-faq.questions.payoffs' | translate }}</p>
      <p class="qa-list__answer">
        {{ 'help-faq.answers.payoffs.DISBURSEMENT_INTRO' | translate }} <span appHighlightData>{{disbursementDate()}}</span>.
      </p>

      <p class="qa-list__answer">
        {{ 'help-faq.answers.payoffs.CREDITOR' | translate }}
      </p>

      @for (payoff of payoffs(); track payoff.recipient) {
      <div class="qa-list__answer">
        <p appHighlightData>{{ payoff.recipient }}</p>
        <p appHighlightData>{{ payoff.amount | currency }}</p>
      </div>
      }
    </div>
    }
  }

  @case('morethaniowe') {
    @if(cashToCloseFinalIsFromBorrower() === false) {
    <div>
      <p class="qa-list__question">
        {{ 'help-faq.questions.morethaniowe' | translate }}
      </p>

      <p class="qa-list__answer">
        {{ 'help-faq.answers.morethaniowe' | translate }}
      </p>
    </div>
    }
  }

  @default {
    @if (showMissing) {
    <div class="qa-list__item">
      @if (item.question) {
      <p class="qa-list__question">{{ item.question }}</p>
      }
      @if (item.answer) {
      <p class="qa-list__answer">{{ item.answer }}</p>
      }
    </div>
    }
  }
  }
  }
</div>
